export default __webpack_public_path__ + "static/media/logo.dac08747.svg";